import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { allApis } from "../../../request/config";
import apiRequest from "../../../request/apiRequest/apiRequest";

export const fetchAllClusterQues = createAsyncThunk(
  "QuestionReview/fetchAllClusterQues",
  async (param: string) => {
    try {
      if (param) {
        const ques: any = await apiRequest({
          api: allApis.getClusterQuesList(param),
          method: "GET",
        });
        return ques ?? []; // Assuming the API returns the data directly
      } else {
        return [];
      }
    } catch (error: any) {
      return null;
    }
  }
);
export const mappingUpdate = createAsyncThunk(
  "QuestionReview/mappingUpdate",
  async ({id,body}: { id:number, body:{"status"?:"save_for_later"|"pending"|"reviewed";
  "cluster"?:number}}) => {
    try {
        const ques: any = await apiRequest({
          api: allApis.mappingUpdate(id),
          method: "PUT",
            payload:body,
        });
        return ques ?? []; // Assuming the API returns the data directly
    
    } catch (error: any) {
      return null;
    }
  }
);
export const getQuestionComments = createAsyncThunk(
  "QuestionReview/getQuestionComments",
  async (id:string) => {
    try {
        const ques: any = await apiRequest({
           api: allApis.comments.get(id),
          method: "GET",
        });
        return ques ?? []; // Assuming the API returns the data directly
    
    } catch (error: any) {
      return null;
    }
  }
);


interface QuestionReviewState {
  questions: any[];
  queLoading: boolean;
  comments:any[]
}
const initialState: QuestionReviewState = {
  questions: [],
  queLoading: false,
  comments:[]
};
const QuestionReviewSlice = createSlice({
  name: "contentFeedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllClusterQues.pending, (state) => {
        state.queLoading = true;
      })
      .addCase(fetchAllClusterQues.fulfilled, (state, action) => {
        state.queLoading = false;
        state.questions = action.payload;
      })
      .addCase(fetchAllClusterQues.rejected, (state, action) => {
        state.queLoading = false;
      }).addCase(mappingUpdate.pending, (state) => {
        state.queLoading = true;
      })
      .addCase(mappingUpdate.fulfilled, (state, action) => {
        state.queLoading = false;
        // state.questions = action.payload;
      })
      .addCase(mappingUpdate.rejected, (state, action) => {
        state.queLoading = false;
      }) .addCase(getQuestionComments.pending, (state) => {
        state.queLoading = true;
        state.comments =  [];
      })
      .addCase(getQuestionComments.fulfilled, (state, action) => {
        state.queLoading = false;
        state.comments = action.payload;
      })
      .addCase(getQuestionComments.rejected, (state, action) => {
        state.queLoading = false;
      });
  },
});

export default QuestionReviewSlice.reducer;
